export const addSpaceToString = (string)=>{
    const splited = string.split(',')
    const newString = splited.join(', ')
    return newString
}